import React, { useEffect, useState } from "react";
import { YOUTUBE_VIDEOS_API } from "../utils/constants";
import VideoCard from "./VideoCard";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addApiData } from "../utils/apiDataSlice";


const VideoContainer = () => {
  const [videos, setVideos] = useState([]);
  const [channelIcon] = useState([]);
  const searchResults = useSelector(store=>store.searchResults.response);
  const dispatch = useDispatch();


  useEffect(() => {
    getVideos();

  }, []);

  const getVideos = async () => {
    const data = await fetch(YOUTUBE_VIDEOS_API);
    const json = await data.json();
    console.log("json video container:>> ", json.items);
    setVideos(json.items);
    dispatch(addApiData(json.items));
    
  };
  console.log('searchResults mald :>> ', searchResults);

  if (!searchResults) return (
    <div className="flex flex-wrap  justify-evenly ">
      {videos &&videos.map((video) => (
        <Link key={video.id} to={"/watch?v=" + video.id}>
          <VideoCard key={video.id} info={video} icon={channelIcon} />
        </Link>
      ))}
    </div>
  );;

  return (
    <div className="flex flex-wrap  justify-center ">
      {searchResults.map((s) => (
        <Link key={s.id.videoId } to={"/watch?v=" + s.id.videoId}>
          <VideoCard key={s.id.videoId} info={s} icon={channelIcon} />
        </Link>
      ))}
    </div>
  );


};

export default VideoContainer;
